<template>
  <div>

    <world-map></world-map>

    <div class="row mt-4">
      <div class="navBottom pull-right">
        <p-button class="btn btn-deepDark" @click.prevent="goToShowSoilList()">
            <span>{{ $t('show_list') }}</span> <i class="fa fa-list" style="padding-left:15px"></i>
        </p-button>
         <p-button class="btn btn-yellow" @click.prevent="goToShowSoilScan">
            <span>{{ $t('soil_scans')}}</span> <i class="fa fa-backward" style="padding-left:15px"></i>
        </p-button>
      </div>
    </div>
  </div>
</template>
<script>
import Resource from "@/util/Api/resource.js";
import Loading from 'src/components/Dashboard/Layout/LoadingMainPanel.vue'
const NGOResources = new Resource("category/childrenGivenParent");

const WorldMap = () => ({
    component: import('../../Maps/ShowSoilMap.vue'),
    loading: Loading,
    delay: 200
});

export default {
  components: {
      WorldMap,
  },
  methods: {

    // showing soil list
    goToShowSoilList(){
       this.$router.push({ name: "ShowList" });
    },

    // go back to soil scan page
    goToShowSoilScan(){
      this.$router.push({ name: "Soilscans" });
    },

  },
}
</script>
<style scoped>

  .btn-deepDark {
      background-color: #000000;
      color: white;
      margin-right: 10px;
  }

  .btn-yellow {
     background-color:red;
     color: white;
  }

  .navBottom {
      display: flex;
      position: absolute;
      right: 0;
      width: 330px;
      bottom: 70px;
  }

</style>
